import React, { useState, useEffect } from "react";

import { Assets } from "@sendum/core";
import s from "./ShipmentTimelineIcon.module.scss";

interface ShipmentIconPropsI {
	mode?: string;
	type?: string;
	icons: Map<string, string>;
}

export const ShipmentTimelineIcon = ({ mode, type, icons }: ShipmentIconPropsI): JSX.Element | null => {
	const [styleClass, setStyleClass] = useState<string>("");

	useEffect(() => {
		const colorClass = type === "Route" ? s.route : s.node;
		setStyleClass([s.iconWrapper, colorClass].join(" "));
	}, [type]);

	const getIconSrc = (m: string): string => icons.get(m) || Assets.ImgBroken;

	if (!mode || !type) {
		return null;
	}

	return (
		<div className={styleClass}>
			<img
				alt={""}
				src={getIconSrc(mode)}
				className={s.img}
			/>
		</div>
	);
};
